import styled from "styled-components";

export const ContainerModalVariacoesPromocao = styled.div`
  padding: 32px 24px;

  .titulo {
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .subtitulo {
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 4rem;

    strong {
      font-weight: 700;
    }
  }

  .carregando {
    display: flex;
    justify-content: center;
    padding: 6rem 0;
  }

  .vazio {
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};
    padding: 6rem 0;
  }

  .tabela {
    max-height: 45vh;
    overflow-y: auto;
  }

  .celula-nome {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    text-align: left;
    line-height: 1.1;

    .detalhe {
      color: ${(props) => props.theme.colors.placeholder};
    }

    &.bloqueada {
      opacity: 0.5;
    }
  }

  .em-outra {
    color: ${(props) => props.theme.colors.placeholder};
    white-space: nowrap;
  }

  .acao-variacao {
    padding: 0.5rem 2rem !important;
    white-space: nowrap;

    &.remover {
      background-color: ${(props) => props.theme.colors.elements};
      color: ${(props) => props.theme.colors.tertiary};
    }
  }

  .botoes {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    margin-top: 4rem;

    .cancelar {
      display: flex;
      align-items: center;
      gap: 1rem;
      cursor: pointer;
      color: ${(props) => props.theme.colors.tertiary};

      svg {
        fill: ${(props) => props.theme.colors.primary};
        transform: rotate(90deg);
      }
    }
  }
`;

export default ContainerModalVariacoesPromocao;
